import { createFileRoute } from '@tanstack/react-router';

import { getTeamMemberQueryOption } from '@/_pages/team-members/api-service';
import Loading from '@/_pages/team-members/profile/loading';

export const Route = createFileRoute('/_private/team-members/_template/$id/')({
  loader: (opts) => opts.context.queryClient.ensureQueryData(getTeamMemberQueryOption(opts.params.id)),
  staticData: {
    renderRightColumn: true,
    pageTitle: 'Team Member',
    tabKey: 'team-member/profile',
  },
  pendingComponent: Loading,
});
